import {MapProvider} from './MapProvider';

export default MapProvider;